export function Ico84Error({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="84" height="84" viewBox="0 0 84 84" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="42" cy="42" r="42" fill="#ECF6FF" />
      <path
        d="M44.5273 50.2383H37.8555L36.4609 23.5234H45.9219L44.5273 50.2383ZM36.3516 59.5898C36.3516 58.0586 36.7617 56.901 37.582 56.1172C38.4023 55.3333 39.5964 54.9414 41.1641 54.9414C42.6771 54.9414 43.8438 55.3424 44.6641 56.1445C45.5026 56.9466 45.9219 58.0951 45.9219 59.5898C45.9219 61.0299 45.5026 62.1693 44.6641 63.0078C43.8255 63.8281 42.6589 64.2383 41.1641 64.2383C39.6328 64.2383 38.4479 63.8372 37.6094 63.0352C36.7708 62.2148 36.3516 61.0664 36.3516 59.5898Z"
        fill="#0087E0"
      />
    </svg>
  );
}
